import * as React from "react";

import { Checkbox as CheckboxPrimitive } from "@base-ui-components/react/checkbox";

import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

export function ULThemeCheckbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  // Theme overrides for checkbox styling
  const themeOverrides = cn(
    // Square checkboxes - border always the brand checkbox color (blue by
    // default, black for .hotels-theme), not just when checked, and filled
    // with the same color once checked/indeterminate.
    "rounded-none",
    "border-2",
    "border-(--ul-theme-color-accent)",
    "data-checked:bg-(--ul-theme-color-accent)",
    "data-indeterminate:bg-(--ul-theme-color-accent)",
    "data-checked:border-(--ul-theme-color-accent)",
    "data-indeterminate:border-(--ul-theme-color-accent)",
    // White checkmark
    "data-checked:[&_span]:text-white",
    // Ensure proper hover and focus states
    "hover:border-(--ul-theme-color-accent)/50",
    "theme-universal:focus-visible:ring-base-focus/15",
    "hover:cursor-pointer",
  );

  return <Checkbox className={cn(themeOverrides, className)} {...props} />;
}
